import React, {Component} from "react"
import PropTypes from "prop-types"

import Button from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {greys} from "@irati/ui/src/global/colors"
import History from "@irati/utils/history"

import {MetricCard, CircledNumber, CircledWrapper, TickWrapper, IconWrapper, StyledIcon, FullWidth} from "./styled"

export interface Props extends InjectIntl {
  id: string,
  isOpen: boolean,
  index: number,
  isCompleted: boolean,
  title: string,
  text: string,
  buttonText?: string,
  secondaryButtonText?: string,
  page?: string,
  secondPage?: string,
  onClick?: () => void,
  onClickChevron: () => void,
  tracking: () => void,
  secondaryTracking?: () => void
}

class ProgressMetric extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  handleButtonClick = () => {
    const {tracking, onClick, page} = this.props
    tracking()
    if (onClick) {
      return onClick()
    }
    History.push(page, this.context.apps.ADMIN)
  }

  handleSecondaryButtonClick = () => {
    const {secondaryTracking, secondPage} = this.props
    secondaryTracking()
    History.push(secondPage, this.context.apps.ADMIN)
  }

  render() {
    const {
      id,
      formatMessage,
      index,
      isCompleted,
      title,
      text,
      buttonText,
      secondaryButtonText,
      isOpen,
      onClickChevron
    } = this.props

    return (
      <MetricCard isOpen={isOpen} padding={[1, 2, 1]}>
        <Flex>
          <CircledWrapper>
            {isCompleted
              ? <TickWrapper><StyledIcon size={15} icon="tick" flush color={greys.white} /></TickWrapper>
              : <CircledNumber>{index}</CircledNumber>
            }
          </CircledWrapper>
          <FullWidth>
            <Flex justifyContent="space-between">
              <Body fontWeight="bold" marginBottom={1} marginTop={0.5}>{formatMessage({id: title})}</Body>
              <IconWrapper id={id} onClick={onClickChevron}>
                <Icon icon={isOpen ? IconTypes.chevronUp : IconTypes.chevronDown} />
              </IconWrapper>
            </Flex>
            {isOpen &&
              <>
                <Body small marginBottom={1}>{formatMessage({id: text})}</Body>
                <Button id={`${id}_button`} small primary onClick={this.handleButtonClick} marginBottom={2}>
                  {buttonText ? formatMessage({id: buttonText}) : formatMessage({id: title}) }
                </Button>
                {secondaryButtonText &&
                  <Button id={`${id}_secbutton`} small primary onClick={this.handleSecondaryButtonClick} marginBottom={2}>
                    {formatMessage({id: secondaryButtonText})}
                  </Button>
                }
              </>
            }
          </FullWidth>
        </Flex>
      </MetricCard>
    )
  }
}

export default injectIntl(ProgressMetric)
